// ---------------------------------------------------------------------------
// The .ehd stores absolute paths from the PC where the project was created
// (e.g. "G:\My Drive\...\WorkDir1"), which are useless when opening the
// project in the browser from a different folder. These paths DO keep the
// real relative structure (scenario folder, GIS subfolders...) with respect
// to the project root, so it's enough to take their last segments and
// resolve them against the folder the user has chosen.
// ---------------------------------------------------------------------------

/** Last `n` (non-empty) segments of an absolute path, in order. */
export function lastSegments(absolutePath: string, n: number): string[] {
  const parts = absolutePath.split(/[\\/]/).filter((p) => p.length > 0);
  return parts.slice(Math.max(0, parts.length - n));
}

/** Last segment (typically the folder name) of an absolute path. */
export function lastSegment(absolutePath: string): string | null {
  const segments = lastSegments(absolutePath, 1);
  return segments[0] ?? null;
}
